/**
 * Looks of the classic figures, by name (`LOOKS`), and what equipment changes about them (`OUTFITS`).
 * The looks are spread over the files here, each adding its own to `LOOKS` (heroes.ts makes it);
 * they are imported in a fixed order, which is the order `LOOKS` lists them in. A new file of looks
 * is imported here, before the uniforms' coats are dropped. Only this file imports the others.
 */
import { LOOKS } from './heroes';
import './uniforms';
import './people';
import './masked';
import './folk';
import './masters';

export type { FaceStyle, HairStyle, Headwear, Look, Weapon } from './types';
export { hero } from './heroes';
export { OUTFITS } from './outfits';
export { LOOKS };

// A uniform brings its own clothes; the classic overcoat it was drawn with gives way to it (a coat
// from equipment is still laid over the uniform).
for (const look of Object.values(LOOKS)) if (look.school) delete look.coat;

// Each look carries its own id, so its face (rig/faces2/live.ts) is picked by who it is, also on dressed copies.
for (const [id, look] of Object.entries(LOOKS)) look.faceId ??= id;
